var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"cs-checkbox",class:{
        'cs-checkbox--disabled': _vm.disabled,
        'cs-checkbox--unchecked': !_vm.checked,
        'cs-checkbox--small': _vm.small
    }},[_c('input',{staticClass:"cs-checkbox__input",attrs:{"type":"checkbox"},domProps:{"checked":_vm.checked},on:{"change":_vm.input}}),_c('div',{staticClass:"cs-checkbox__box"},[_c('svg-icon',{staticClass:"cs-checkbox__icon",attrs:{"name":"check","width":"16px","height":"12px","middle":""}})],1),_c('div',{staticClass:"cs-checkbox__text"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }